module.exports = __webpack_public_path__ + "static/media/Q5-6.a7f035d5.jpg";